import { API_BASE } from '../../constants/api';
import { buildEstablishmentFormData, buildDoctorFormData, parseApiError } from '../../utils/helpers';
import { mapEstablishmentToProfileForm } from '../../utils/establishmentFormHelpers';
import { mapDoctorToProfileForm } from '../../utils/doctorFormHelpers';

async function putEstablishment(establishment, extra = {}) {
  const fd = buildEstablishmentFormData({
    ...mapEstablishmentToProfileForm(establishment),
    awards_list: establishment.awards_list || [],
    news_list: establishment.news_list || [],
    knowledge_list: establishment.knowledge_list || [],
    ...extra,
    establishment_id: establishment.establishment_id,
  });
  const res = await fetch(`${API_BASE}/master/establishments/${establishment.establishment_id}`, {
    method: 'PUT',
    body: fd,
  });
  if (!res.ok) throw new Error(await parseApiError(res));
  const data = await res.json();
  return data.establishment;
}

async function putDoctor(doctor, extra = {}) {
  const fd = buildDoctorFormData({
    ...mapDoctorToProfileForm(doctor),
    ...extra,
    doctor_id: doctor.doctor_id,
  });
  const res = await fetch(`${API_BASE}/master/doctors/${doctor.doctor_id}`, {
    method: 'PUT',
    body: fd,
  });
  if (!res.ok) throw new Error(await parseApiError(res));
  const data = await res.json();
  return data.doctor;
}

export async function uploadEstablishmentLogo(establishment, file) {
  return putEstablishment(establishment, { logo: file });
}

export async function uploadEstablishmentBanner(establishment, file) {
  return putEstablishment(establishment, { gallery_images: [file] });
}

export async function uploadDoctorProfilePic(doctor, file) {
  return putDoctor(doctor, { profile_pic: file });
}
